import { PlanT } from '@segurodeceso/core/domain/plans';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import storage from './encryptedStorage';

interface PlansStoreStateI {
  plans: PlanT[];
  isInitialized: boolean;
  setPlans: (plans: PlanT[]) => void;
}

const usePlansStore = create<PlansStoreStateI>()(
  persist(
    (set) => ({
      plans: [],
      isInitialized: false,
      setPlans: (plans) => set({ plans, isInitialized: true }),
    }),
    {
      name: 'deceso-plans-storage',
      storage,
    }
  )
);

export default usePlansStore;
